import type { ReactElement } from 'react';
import React, { useEffect } from 'react';
import SidebarCollapsed from './sidebar-collapsed';
import SidebarFull from './sidebar-full';
import './sidebar.scss';

type Props = {
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function Sidebar({ sidebarOpen, setSidebarOpen }: Props): ReactElement | null {
  useEffect(() => {
    // start with open side bar
    setSidebarOpen(true);
  }, [setSidebarOpen]);

  useEffect(() => {
    const resizeListener = (): void => {
      if (window.innerWidth <= 760) {
        setSidebarOpen(false);
      }
    };
    // change state on resize
    window.addEventListener('resize', resizeListener);
    resizeListener();
    return () => window.removeEventListener('resize', resizeListener);
  }, [setSidebarOpen]);

  return sidebarOpen ? (
    <SidebarFull setSidebarOpen={setSidebarOpen} />
  ) : (
    <SidebarCollapsed setSidebarOpen={setSidebarOpen} />
  );
}
